import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { storeAccountInformation } from './../../store/actions/AuthenticationAction';
import { connect } from 'react-redux';
import {
    AuthenticatedTemplate,
    MsalProvider,
    UnauthenticatedTemplate
} from '@azure/msal-react';
import MainView from './index';
import {
    getAccessToken,
    initMSAL,
    getUser,
    getRemoteAccountSession
} from '../../authProvider';
class Auth extends Component {
    constructor(props) {
        super(props);

        this.msalInstance = initMSAL(this.updateMSALInformation);
    }

    updateMSALInformation = (response) => {
        this.onUpdateAccount(response.payload.account);
    };

    onUpdateAccount = (account) => {
        if (account !== undefined && account !== null) {
            this.props.storeAccountInformation(account);
        }
    };

    async componentDidMount() {
        if (getUser() == null) await getAccessToken();

        // If not logged in, check B2C session cookie with popup
        await getRemoteAccountSession();
    }

    render() {
        return (
            <MsalProvider instance={this.msalInstance}>
                <AuthenticatedTemplate>
                    <MainView />
                </AuthenticatedTemplate>
                <UnauthenticatedTemplate>
                    <div />
                </UnauthenticatedTemplate>
            </MsalProvider>
        );
    }
}

Auth.propTypes = {
    clientId: PropTypes.string,
    authority: PropTypes.string,
    scopes: PropTypes.string,
    token: PropTypes.object,
    redirectUri: PropTypes.string,
    onUpdateToken: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        error: state.authenticationReducer.error
    };
};

const mapDispatchToProps = {
    storeAccountInformation
};

const AuthMain = connect(mapStateToProps, mapDispatchToProps)(Auth);
export default AuthMain;
